 export const CurrencyCodesEnum =Object.freeze({
     USD : "USD",
     IDR : "IDR"
});